export { NFTCollectionFactory } from '@f8n/f8n-contracts/dist/abis/NFTCollectionFactory.generated';
